import { ACTION_PLAN_STATUS_OPTIONS } from 'components/ActionPlans/constants';
import { ActionPlansCompanyFiltersState } from 'types/actionPlans';
import { SelectAdvancedFilterOptionType } from 'types/common';

export const OVERALL_VIEW_KEY = 'overall';

export const EMPTY_FILTERS: ActionPlansCompanyFiltersState = {
  statuses: [],
  communityIds: [],
  planStatuses: [],
  search: '',
};

export const ACTION_PLANS_COMPANY_STATUS = {
  OVERDUE: 'overdue',
} as const;

export const PLAN_STATUS_OPTIONS: SelectAdvancedFilterOptionType[] = [
  ...ACTION_PLAN_STATUS_OPTIONS,
  { label: 'Overdue', value: ACTION_PLANS_COMPANY_STATUS.OVERDUE },
];

export const FILTER_LABEL = {
  STATUS: 'Status',
  COMMUNITY: 'Community',
  PLAN_STATUS: 'Plan Status',
} as const;

export const ACTION_PLANS_COMPANY_SUMMARY_TITLE = {
  TOTAL_PLANS: 'Total Plans',
  COMPLETION_RATE: 'Completion Rate',
  OVERDUE: 'Overdue',
  MOST_COMMON_FOCUS_AREA: 'Most Common Focus Area',
} as const;
